import React, { FC } from 'react';
import RemoveLineItemButton from 'components/SalesArea/pages/Cart/RemoveLineItemButton';
import { useCheckoutLineItemsRemoveMutation } from 'graphql/shopify-store-front-api/queries/types.d';

type Props = {
  /**
   * 削除対象のlineItemId
   */
  lineItemId: string;
};

/**
 * 商品削除ボタンのロジック部
 */
const EnhancedRemoveLineItemButton: FC<Props> = ({ lineItemId }) => {
  const [
    checkoutLineItemsRemoveMutation,
    { loading: checkoutLineItemsRemoveLoading },
  ] = useCheckoutLineItemsRemoveMutation({
    variables: {
      checkoutId: localStorage.getItem('checkoutId') ?? '',
      lineItemIds: [lineItemId],
    },
  });

  return (
    <RemoveLineItemButton
      isLoading={checkoutLineItemsRemoveLoading}
      onClick={checkoutLineItemsRemoveMutation}
    />
  );
};

export default EnhancedRemoveLineItemButton;
